/**
 * Rule that checks whether elements are named
 */
const { is } = require("bpmnlint-utils");

const STEP_TYPES = ["bpmn:Task", "bpmn:UserTask", "bpmn:SubProcess", "bpmn:CallActivity"];

function isWorkflowStep(node) {
  return STEP_TYPES.some((t) => is(node, t));
}

function getNodeName(node) {
  const bo = node.businessObject || {};
  const name = bo.name || node.name;
  return typeof name === "string" ? name.trim() : "";
}

module.exports = function labelRequired() {
  return {
    check(node, reporter) {
      if (!node) return;

      if (!isWorkflowStep(node)) return;

      const name = getNodeName(node);

      if (!name) {
        reporter.report(node.id, "This element should have a non-empty label (name).");
      }
    }
  };
};
